"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchRetailCustomerSalesOrders = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const useClient_1 = require("../../../../hooks/useClient");
const useFetchRetailCustomerSalesOrders = (retailCustomerId, type, params) => {
    const client = (0, useClient_1.useClient)();
    const { error, isLoading, refetch } = (0, react_query_1.useQuery)(["retrieveRetailCustomerSalesOrders", retailCustomerId, type, params], () => {
        if (retailCustomerId === null) {
            return;
        }
        return client.retailSalesOrders.retrieveRetailCustomerSalesOrders(retailCustomerId, type, params);
    }, {
        retry: 0,
        enabled: false,
        onSuccess: (data) => data,
        onError: (error) => error
    });
    return (0, react_1.useMemo)(() => ({
        isLoading,
        error,
        refetch
    }), [isLoading, error, refetch]);
};
exports.useFetchRetailCustomerSalesOrders = useFetchRetailCustomerSalesOrders;
//# sourceMappingURL=useFetchRetailCustomerSalesOrders.js.map